import { z } from 'zod';

/** the driver types */
export const driverTypesSchema = z.enum([
  'freelancer_driver',
  'carrier_company_driver',
]);
/** the driver types */
export type DriverTypes = z.infer<typeof driverTypesSchema>;
